import axios from 'axios'
import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './forgot-pass.css'

export default function ForgotPassword(){
    const [validUser,setValidUser]=useState(false)
    const [newData,setOldData]=useState({})
    const navigate=useNavigate()
    const email=useRef(null)
    const dob=useRef(null)
    const password=useRef(null)
    const rePassword=useRef(null)
    const PORT=process.env.REACT_APP_URL_PORT

    function findUser(){
        axios.post(`https://${PORT}/admin/user_search`,{id: email.current.value})
        .then(res=>{
            if(res.data.dob === dob.current.value){
                setValidUser(true)
                setOldData(res.data)
            }
        })
    }
    function setNewPassword(){
        let oldData=newData
        oldData.password=password.current.value
        setOldData(oldData)
        axios.post(`https://${process.env.REACT_APP_URL_PORT}/admin/update_user`,newData)
        .then(navigate('/login'))
    }
    return(
        <div className="row">
            <div className="col-md-3 "></div>
                <div className="col-md-6 mt-5 fim">
                    <center>
                        <h3 >𝄞 SANGEET</h3>
                        {!validUser?
                            <>
                                <label>E-mail:</label>
                                <input type="email" ref={email}/><br/>
                                <label>What is your date of birth?</label>
                                <input type="date" ref={dob}/><br/>
                                <button type="button" className="btn btn-primary btn-sm" onClick={findUser}>Check</button><br/>
                            </>:
                            <>
                                <label>New Password:</label>
                                <input type="password" ref={password} /><br/>
                                <label>Re-enter Password:</label>
                                <input type="password" ref={rePassword} /><br/>
                                <button type="submit" className="btn btn-dark btn-sm" onClick={setNewPassword}>Submit</button>
                            </>
                        }
                        
                    </center>
                </div>
            <div className="col-md-3"></div>
        </div>
    )
}